// Threshold at or below which citations render fully inline. Above this,
// the first CITATION_INLINE_PREVIEW items render inline followed by a
// "+N" affordance that opens a popover with all sources.
//
// Current behavior: runs of 3 or fewer render inline as individual chips;
// runs of 4+ collapse entirely into a single "+N" chip (no preview chips).
export const CITATION_INLINE_LIMIT = 3;
export const CITATION_INLINE_PREVIEW = 0;

export const CITATION_POPOVER_WIDTH_PX = 360;
export const CITATION_POPOVER_MAX_HEIGHT_VH = 60;
